// The status titles each colour band carried in a time-series load — the names
// BaseTimeSeriesChart's PNG legend gives the bands (its `fetchLegendTitles`). Both issue-analysis
// time-series queries return a `titles` column (the bucket's status titles, `', '`-joined) next to
// each colour; the old SFCs named their series from it and handed those names to the PNG export.
// Kept here, from the last load, so the export asks no query of its own (project-overview's
// configs query the visible buckets instead — its SQL returns no titles).
//
// A band's names are the union of its titles across every bucket, in first-seen order — what the
// burndown SFC did. (The velocity SFC kept only the first active bucket's titles, so a band whose
// statuses first appeared in different buckets lost names; that is the one change.)
//
//   const bandTitles = makeBandTitles();
//   bandTitles.collect(rows);                // in fetchSeries, the raw rows
//   await bandTitles.fetchLegendTitles();    // → [{ color, title }, …]
export function makeBandTitles() {
  let byColor = new Map();

  const collect = (rows) => {
    byColor = new Map();
    rows.forEach((row) => {
      if (!byColor.has(row.color)) byColor.set(row.color, []);
      const titles = byColor.get(row.color);
      (row.titles ? row.titles.split(', ') : []).forEach((title) => {
        if (title && !titles.includes(title)) titles.push(title);
      });
    });
  };

  // BaseTimeSeriesChart calls it with (visibleTimeKeys, groupBy); the names cover every bucket,
  // and the base keeps only the bands with data in the visible range
  const fetchLegendTitles = async () =>
    [...byColor].flatMap(([color, titles]) => titles.map((title) => ({ color, title })));

  return { collect, fetchLegendTitles };
}
